/**
 * Componente que muestra la vista previa de un álbum con su imagen de carátula
 * y un contador de elementos. Adaptado para la web.
 */

import React, { useState } from 'react';

/**
 * Componente AlbumCover
 * 
 * Muestra la vista previa de un álbum en modo grilla con imagen de carátula y contador.
 * 
 * @param {Array} visibleImages - Lista de imágenes visibles en el álbum
 * @param {Object} coverImage - Imagen de carátula específica (opcional)
 * @param {Function} onPress - Callback al hacer clic en el álbum
 * @param {Object} style - Estilos adicionales
 * @param {number} height - Altura del componente (default: 200px)
 */
export default function AlbumCover({ 
  visibleImages = [], 
  coverImage, 
  onPress, 
  style,
  height = 200 
}) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const imageUrl = coverImage?.url || visibleImages[0]?.url;

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  return (
    <button
      onClick={onPress}
      className="rounded-lg relative w-full cursor-pointer hover:opacity-90 transition-opacity"
      style={{ ...style, height }}
    >
      {(imageUrl && !imageError) ? (
        <>
          {!imageLoaded && (
            <div 
              className="w-full rounded-lg flex items-center justify-center absolute top-0 left-0"
              style={{ 
                height, 
                backgroundColor: '#2A183D'
              }}
            >
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-red-600"></div>
            </div>
          )}
          <img
            src={imageUrl}
            alt="Álbum"
            className="w-full h-full object-cover rounded-lg"
            style={{ filter: 'blur(20px)' }}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />

          <div 
            className="w-full rounded-lg flex items-center justify-center absolute top-0 left-0 backdrop-blur-md"
            style={{ 
              height, 
              backgroundColor: 'rgba(0,0,0,0.4)' 
            }}
          >
            <span className="text-base text-center text-white mt-2">
              {visibleImages.length} Elementos
            </span>
          </div>
        </>
      ) : (
        <div 
          className="w-full bg-neutral-900 dark:bg-neutral-900 rounded-lg flex items-center justify-center"
          style={{ height }}
        >
          <span className="text-base text-center text-white mt-2">
            {visibleImages.length} Elementos
          </span>
        </div>
      )}
    </button>
  );
}
